"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UpdateBlogSettings = _interopRequireDefault(require("../../stagedObjects/UpdateBlogSettings"));

var _actions = require("settings-ui-sdk/BlogPosts/actions");

var _BlogSettingsPageContainer = _interopRequireDefault(require("../BlogSettingsPageContainer"));

var _AsyncGoogleAMPSettings = _interopRequireDefault(require("./AsyncGoogleAMPSettings"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var GoogleAMPContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GoogleAMPContainer, _PureComponent);

  function GoogleAMPContainer() {
    (0, _classCallCheck2.default)(this, GoogleAMPContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoogleAMPContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(GoogleAMPContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadBlogPosts();
    }
  }, {
    key: "getChangesDescription",
    value: function getChangesDescription() {
      var numberOfStagedChanges = this.props.numberOfStagedChanges;
      var langKey = numberOfStagedChanges === 1 ? 'stagedChangeAMPPreview' : 'stagedChangesAMPPreview';
      return _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.blog." + langKey,
        options: {
          numberOfStagedChanges: numberOfStagedChanges
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_BlogSettingsPageContainer.default, {
        changesDescription: this.getChangesDescription()
      }, _react.default.createElement(_AsyncGoogleAMPSettings.default, null));
    }
  }]);
  return GoogleAMPContainer;
}(_react.PureComponent);

GoogleAMPContainer.propTypes = {
  loadBlogPosts: _react.PropTypes.func.isRequired,
  numberOfStagedChanges: _react.PropTypes.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var numberOfStagedChanges = _UpdateBlogSettings.default.isChanged('id')(state) ? 0 : _UpdateBlogSettings.default.numberOfChanges(state);
  return {
    numberOfStagedChanges: numberOfStagedChanges
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  loadBlogPosts: _actions.loadBlogPosts
})(GoogleAMPContainer);

exports.default = _default;
module.exports = exports.default;